import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

async function create(data) {
  const response = await http.postData("/hasil-pemeriksaan-usg", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id, data) {
  const response = await http.putData(`/hasil-pemeriksaan-usg/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http.getData(`/register/${register_id}/hasil-pemeriksaan-usg`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/hasil-pemeriksaan-usg/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function signDokter(id: number, data) {
  const response = await http.putData(`/hasil-pemeriksaan-usg/${id}/sign-dokter`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/hasil-pemeriksaan-usg/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  const data = isEmpty(response?.data) ? null : response.data;
  return data;
}

function print(id) {
  window.open(`${http.getAPI()}/hasil-pemeriksaan-usg/${id}/pdf`, "_blank");
}

async function uploadFoto(
  id: number,
  file: File,
  meta: { catatan?: string; taken_at?: string } = {}
) {
  try {
    const form = new FormData();
    form.append("file", file);
    if (meta.catatan) form.append("catatan", meta.catatan);
    if (meta.taken_at) form.append("taken_at", meta.taken_at);
    const res = await http.postData(`/hasil-pemeriksaan-usg/${id}/foto`, form);
    return res?.data?.data ?? null;
  } catch (e) {
    ErrorAlert.showErrorAlert(e);
    return null;
  }
}

async function deleteFoto(id: number, fotoId: number): Promise<boolean> {
  try {
    await http.deleteData(`/hasil-pemeriksaan-usg/${id}/foto/${fotoId}`);
    return true;
  } catch (e) {
    ErrorAlert.showErrorAlert(e);
    return false;
  }
}

export default {
  create,
  update,
  getByRegister,
  find,
  signDokter,
  destroy,
  uploadFoto,
  deleteFoto,
  print
};
